export default __webpack_public_path__ + "static/media/cp_geo_fi.9e1821c8.svg";